// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"2b08a3f0cec613540fae","883":"6f6d09573881ec81955d"}[chunkId] + ".js";
};